module.exports = __webpack_public_path__ + "static/media/layout.a2d597ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/layout.jpg
// module id = 2307
// module chunks = 0